const langtrans={
      ajgl:["案件管理","Case Management"],
      zxlajg:["咨询类案件管理","咨询类案件管理"],
      gb:["关闭","en_translated"],
      ljydks:["连接已断开，是否重新连接","en_translated"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/views/commonPage/js/service.vue.trans.js